import React, { useState, useCallback, useEffect } from 'react'
import { InputTextarea } from 'primereact/inputtextarea';
import '../design.css'
import InfoIcon from '../../../shared-components/Info-Icon/InfoIcon';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from "primereact/dropdown";
import { ColorPicker } from 'primereact/colorpicker';
import { validateFooter } from '../Helpers/Validations';
import '../settings.css'
const FooterSettings = (props) => {
    const { dataContent, onChange, error, setError } = props;
    const [bgColor, setBgColor] = useState(
        dataContent.footerBackgroundcolor
    );
    const [nextButtonColor, setNextButtonColor] = useState(dataContent.nextbuttonstyle["background-color"]);
    const [previousButtonColor, setPreviousButtonColor] = useState(dataContent.previousbuttonstyle["background-color"]);

    useEffect(() => {
        console.log("hey eeror", error);
    }, [error])

    useEffect(() => {
        if (dataContent)
            setError(validateFooter(dataContent))
        return () => { }
    }, [dataContent])

    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        }
    }

    const debouncedOnChange = useCallback(
        debounce(
            (event) =>
                onChange(event, 'footerBackgroundcolor'),
            500
        ),
        []
    );

    const onChangeColor = (event) => {
        setBgColor(`#${event.value}`);
        debouncedOnChange(event);
    };

    const debouncedOnTitleChange = useCallback(
        debounce(
            (event) =>
                onChange(event, 'nextbuttonstyle'),
            500
        ),
        []
    );
    const onNextButtonColorChange = (event) => {
        setNextButtonColor(`#${event.value}`);
        debouncedOnTitleChange(event);
    };
    const onPreviousButtonColorChange = (event) => {
        setPreviousButtonColor(`#${event.value}`);
        debouncedOnPreviousChange(event);
    };
    const debouncedOnPreviousChange = useCallback(
        debounce(
            (event) =>
                onChange(event, 'previousbuttonstyle'),
            500
        ),
        []
    );
    const handlePrevBtnColor = (event) => {
        const value = event.target.value;
        // Check if the input value is a valid color code
        if (/^#[0-9A-F]{6}$/i.test(value)) {
            onPreviousButtonColorChange(value);
        }
        setPreviousButtonColor(value);

    }

    const handleNxtBtnColor = (event) => {
        const value = event.target.value;
        // Check if the input value is a valid color code
        if (/^#[0-9A-F]{6}$/i.test(value)) {
            onNextButtonColorChange(value);
        }
        setNextButtonColor(value);
    }
    const handleFooterTextColor = (event) => {
        const value = event.target.value;
        // Check if the input value is a valid color code
        if (/^#[0-9A-F]{6}$/i.test(value)) {
            onChangeColor(value);
        }
        setBgColor(value);
    }
    return (
         <div className="">
    {/* Progress Bar */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">Progress Bar</div>
      <div className="col-12 col-md-7 col-lg-5 control-col">
        <InputSwitch
          checked={dataContent.progressbar}
          onChange={(e) => onChange(e, "progressbar", dataContent)}
        />
      </div>
    </div>

    {/* Next Button Label */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">Next Button Label</div>
      <div className="col-12 col-md-7 col-lg-5 control-col">
        <input
          type="text"
          className="form-control form-control-md"
          placeholder="Enter your text here"
          onChange={(e) => onChange(e, "nextbuttonlabel", dataContent)}
          value={dataContent.nextbuttonlabel || ""}
        />
        {error.nextLabel && (
          <span className="error-message">{error.nextLabel}</span>
        )}
      </div>
    </div>

    {/* Next Button Colour */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">Next Button Colour</div>
      <div className="col-12 col-md-7 col-lg-5 control-col d-flex align-items-center gap-2">
        <input
          type="text"
          className="form-control form-control-md"
          value={nextButtonColor}
          onChange={handleNxtBtnColor}
        />
        <ColorPicker value={nextButtonColor} onChange={onNextButtonColorChange} />
      </div>
    </div>

    {/* Previous Button Label */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">Previous Button Label</div>
      <div className="col-12 col-md-7 col-lg-5 control-col">
        <input
          type="text"
          className="form-control form-control-md"
          placeholder="Enter your text here"
          onChange={(e) => onChange(e, "previousbuttonlabel", dataContent)}
          value={dataContent.previousbuttonlabel || ""}
        />
        {error.previousLabel && (
          <span className="error-message">{error.previousLabel}</span>
        )}
      </div>
    </div>

    {/* Previous Button Colour */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">Previous Button Colour</div>
      <div className="col-12 col-md-7 col-lg-5 control-col d-flex align-items-center gap-2">
        <input
          type="text"
          className="form-control form-control-md"
          value={previousButtonColor}
          onChange={handlePrevBtnColor}
        />
        <ColorPicker
          value={previousButtonColor}
          onChange={onPreviousButtonColorChange}
        />
      </div>
    </div>

    {/* Footer Background Colour */}
    <div className="row align-items-center form-row">
      <div className="col-12 col-md-5 col-lg-4 tab-view">
        Survey Footer Background Colour
      </div>
      <div className="col-12 col-md-7 col-lg-5 control-col d-flex align-items-center gap-2">
        <input
          type="text"
          className="form-control form-control-md"
          value={bgColor}
          onChange={handleFooterTextColor}
        />
        <ColorPicker value={bgColor} onChange={onChangeColor} />
      </div>
    </div>
  </div>
    )
}


export default FooterSettings